(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('TargetAudienceFactory', TargetAudienceFactory);

    /** @ngInject */
    function TargetAudienceFactory ($resource) {
        var resourceUrl =  'admin/api/target-audience';
        var filtersPath = '/filters';

        return $resource(resourceUrl, {}, {
            'listAll': {
                url: resourceUrl,
                method: 'GET',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'getAllFilters': {
                url: resourceUrl + filtersPath,
                method: 'GET',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'save': {
                url: resourceUrl,
                method: 'POST',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'delete': {
                method:'DELETE',
                url: resourceUrl + '/:id',
            },
            'findById': {
                method:'GET',
                url: resourceUrl + '/:id',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            }
        });
    }
})();
